import {
    Button,
    Col,
    Form,
    Input,
    Modal,
    Row,
    Select,
    Image,
    DatePicker,
    Drawer,
    Switch,
} from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import LocationMap from "../User/LocationMap";
import SingleImageUpload from "../../components/SingleImageUpload";
const { RangePicker } = DatePicker;

const allowedImageTypes = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/webp",
];

const visibilityOptions = [
    { label: "Web", value: "web" },
    { label: "Mobile App", value: "app" },
    { label: "Both", value: "both" },
];

const AddForm = ({ api, show, hide, data, refresh }) => {
    const [form] = Form.useForm();
    const { request } = useRequest();
    const [image, setImage] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleImage = (files) => {
        if (files.length > 0) {
            setImage(files[0].url);
            form.setFieldsValue({ image: files[0]?.url || null });
        } else {
            setImage(null);
            form.setFieldsValue({ image: null });
        }
    };

    useEffect(() => {
        if (!data) return;

        const dates = data.start_date && data.end_date
            ? [moment(data.start_date), moment(data.end_date)]
            : null;

        setImage(data?.image);
        form.setFieldsValue({
            ...data,
            date_range: data?.start_date && data?.end_date ? [moment(data.start_date), moment(data.end_date)] : [],
        });
    }, [data]);

    const onCreate = (values) => {
        setLoading(true);
        const payload = {
            ...values,
            image,
            start_date: values.date_range?.[0] || null,
            end_date: values.date_range?.[1] || null,
        };

        request({
            url: `${data ? `${api.addEdit}/${data._id}` : api.addEdit}`,
            method: "POST",
            data: payload,
            onSuccess: (res) => {
                setLoading(false);
                if (res.status) {
                    ShowToast(res.message, Severty.SUCCESS);
                    hide();
                    refresh();
                } else {
                    ShowToast(res.message, Severty.ERROR);
                }
            },
            onError: (error) => {
                setLoading(false);
                ShowToast(error.response?.data?.message, Severty.ERROR);
            },
        });
    };

    return (
        <Drawer
            title={`${data ? "Edit" : "Add"} Banner`}
            width={window.innerWidth < 768 ? "100%" : 500}
            onClose={() => {
                hide();
                form.resetFields();
                setImage(null);
            }}
            open={show}
            destroyOnClose
            footer={null}
        >
            <Form form={form} layout="vertical" onFinish={onCreate}>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Form.Item label="Banner Title (Optional)" name="title" normalize={(value) => value?.trimStart()}
                        >
                            <Input placeholder="Enter banner title" />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            name="image"
                            label="Banner Image"
                            rules={[{ required: true, message: "Please upload banner image" }]}
                        >
                            <SingleImageUpload
                                value={image ? [{ url: image }] : []}
                                fileType={allowedImageTypes}
                                imageType="image"
                                btnName="Upload Banner"
                                onChange={handleImage}
                            />
                        </Form.Item>
                        <div style={{ fontSize: "12px", color: "#999" }}>
                            ⚠️ Recommended formats: PNG, JPG, WebP | Max 5MB
                        </div>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="Redirect URL (Optional)"
                            name="redirect_url"
                            normalize={(value) => value?.trimStart()}
                            rules={[
                                {
                                    type: 'url',
                                    message: 'Please enter a valid URL (e.g., https://example.com)',
                                    warningOnly: true,
                                },
                            ]}
                        >
                            <Input placeholder="https://example.com/page" />
                        </Form.Item>
                    </Col>


                    <Col span={24}>
                        <Form.Item
                            label="Visibility"
                            name="visibility"
                            rules={[{ required: true, message: "Please select visibility" }]}
                        >
                            <Select placeholder="Select where this banner is shown">
                                {visibilityOptions.map((item) => (
                                    <Select.Option key={item.value} value={item.value}>
                                        {item.label}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item label="Schedule (Optional)" name="date_range">
                            <RangePicker
                                style={{ width: "100%" }}
                                disabledDate={(current) => {
                                    return current && current < moment().startOf('day');
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <div className="d-flex justify-content-end">
                            <Button onClick={hide} style={{ marginRight: 8 }}>
                                Cancel
                            </Button>
                            <Button type="primary" htmlType="submit" loading={loading}>
                                {data ? "Update" : "Add"}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    );
};


export default AddForm;
